@if(visibleSpinner()){
<div class="d-flex flex-column justify-content-center align-items-center text-center">
    <span class="loader"></span>
    @if(message() != ""){
    <div class="mt-3 message-spinner">
        {{message()}}
    </div>
    }
</div>

}